import AsyncAutocompleteInput from '../inputs/AsyncAutocompleteInput';
import createField from './createField';

const AsyncAutocompleteField = createField(AsyncAutocompleteInput);

export default AsyncAutocompleteField;
